import * as v from "valibot";
import { BaseRecordSchema, baseVals, defineValidation, listVals } from "../../common/validation.common";

export namespace APIKeyValidation {
    export const Record = defineValidation(BaseRecordSchema);

    export const Create = defineValidation(
        v.object({
            name: baseVals.string("Nama"),
            notes: baseVals.string("Catatan"),
            privileges: listVals.stringList("Hak Akses"),
        }),
    );

    export const Update = defineValidation(
        v.object({
            name: v.exactOptional(baseVals.string("Nama")),
            notes: v.exactOptional(baseVals.string("Catatan")),
            privileges: v.exactOptional(listVals.stringListEmptiable()),
        }),
    );
}
